import {Injectable} from '@angular/core';
import {Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {UserEnEchange} from './user-en-echange.model';
import {DateUtils} from 'ng-jhipster';

// Attention ne pas changer les valeurs, elles sont enregistrees dans la bdd
export enum TypeEtudiantEnumeration {
    'enEchange' = 0,
    'restrictionEmail' = 1
}

@Injectable()
export class UserEnEchangeService {

    private resourceUrl = 'api/user-en-echange';
    private resourceRestrictionEmailCount = 'api/user-en-echange/findAllPourCampagneRestrictionEmail';

    private static copyUser(userEnEchange: UserEnEchange): UserEnEchange {
        if (userEnEchange.dateNaissance != null) {
            userEnEchange.dateNaissance = new Date(userEnEchange.dateNaissance.getFullYear(),
                userEnEchange.dateNaissance.getMonth(), userEnEchange.dateNaissance.getDate(),
                userEnEchange.dateNaissance.getHours(), userEnEchange.dateNaissance.getMinutes());
        }
        return userEnEchange;
    }

    constructor(private http: Http, private dateUtils: DateUtils) {
    }

    query(typeEtudiant: Number, req?: any): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        if (req) {
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }
        params.set('typeEtudiant', typeEtudiant.toString());
        let options = {
            search: params
        };

        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res));
    }

    getRestrictionEmail(idCampagne: number): Observable<Response> {
        return this.http.get(`${this.resourceRestrictionEmailCount}/${idCampagne}`)
            .map((res: any) => this.convertResponse(res));
    }
    create(userEnEchange: UserEnEchange): Observable<UserEnEchange> {
        return this.http.post(this.resourceUrl, UserEnEchangeService.copyUser(userEnEchange))
            .map((res: Response) => {
                return this.convertHeures(res.json());
            })
            .catch((error: Response) => {
                // Intercepter les erreurs HTTP 409 (Conflict)
                if (error.status === 409) {
                    // Renvoie un observable avec une erreur personnalisée
                    return Observable.throw(
                        new Error('Un utilisateur avec cet email existe déjà.')
                    );
                }
                // Pour les autres erreurs, renvoyer l'erreur originale
                return Observable.throw(error);
            });
    }
    createOLD(userEnEchange: UserEnEchange): Observable<UserEnEchange> {
        return this.http.post(this.resourceUrl, UserEnEchangeService.copyUser(userEnEchange)).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }

    update(userEnEchange: UserEnEchange): Observable<UserEnEchange> {
        return this.http.put(this.resourceUrl, UserEnEchangeService.copyUser(userEnEchange)).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }

    find(id: number): Observable<UserEnEchange> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }


    findByCadensUserId(id: number): Observable<UserEnEchange> {
        return this.http.get(`${this.resourceUrl}/userid/${id}`).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }

    GetEiByCandidatureFormationId(id: number): Observable<UserEnEchange> {
        return this.http.get(`${this.resourceUrl}/ei/${id}`).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }


    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            this.convertHeures(jsonResponse[i]);
        }
        res._body = jsonResponse;
        return res;
    }

    public convertHeures(userEnEchange: UserEnEchange): UserEnEchange {
        userEnEchange.dateNaissance = this.dateUtils
            .convertDateTimeFromServer(userEnEchange.dateNaissance);
        return userEnEchange;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/user-en-echange/user-en-echange.service.ts